import cn from 'classnames';

import Text from 'components/common/Text';
import styles from 'styles/components/signUpFunnel/box/MillionsBanner';

const MillionsBanner = () => {
  return (
    <div
      className={cn(
        styles.background,
        'flex items-center justify-center rounded-2xl border border-solid border-cream-120 bg-cream-110 px-6 pt-8 bp1:mt-10 bp1:px-0 bp1:pb-4 bp1:pt-0'
      )}
    >
      <div className="my-auto flex h-36 flex-col items-center text-center bp1:h-64 bp1:justify-center bp1:py-0">
        <Text brandStylesOverrides="textMd">Over</Text>
        <Text brandStylesOverrides="text-green-100 h2" className="mb-2">
          7 million
        </Text>
        <Text brandStylesOverrides="textMd">boxes delivered in 2025!</Text>
      </div>
    </div>
  );
};

export default MillionsBanner;
